exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "h2{font-size:30px;line-height:30px}h3{font-size:25px;line-height:25px;margin-bottom:0!important}hr{margin-top:.91%!important;margin-bottom:2.35%!important;border-top:1px solid #61d9f2}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/autoprefixer-loader?browsers=last 2 version!./~/sass-loader?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./src/views/auth/registerEditProfileForm.scss
// module id = 1290
// module chunks = 2